import * as React from 'react';
import { Select } from '../../../../components';
import { BasicItem } from '../types';

interface AddItemRowProps {
  item: BasicItem;
  onSelect(item: BasicItem);
}

export const AddItemRow: React.FC<AddItemRowProps> = ({ item, onSelect }) => {
  const handleClick = React.useCallback(() => {
    onSelect(item);
  }, [item, onSelect]);

  return <Select.Row onClick={handleClick}>{item.name}</Select.Row>;
};
